// extracted by mini-css-extract-plugin
export var activeFilterButton = "_nl-c";
export var backButton = "_nl-4";
export var backIcon = "_nl-5";
export var chevronShortcut = "_nl-6";
export var container = "_nl-1";
export var editor = "_nl-8";
export var editorWrapper = "_nl-7";
export var prefix = "_nl-2";
export var searchIcon = "_nl-3";
export var suffix = "_nl-9";
export var suffixContent = "_nl-a";
export var suffixText = "_nl-b";
export var wrapper = "_nl-0";